<template>
<aside class="main-sidebar">
  <section class="sidebar">
    <form @submit.prevent="search" method="get" class="sidebar-form" v-if="isGranted('ROLE_OTHER_SEARCH')">
      <div class="input-group">
        <input v-model="q" type="text" name="q" class="form-control" placeholder="Search...">
        <span class="input-group-btn">
          <button type="submit" name="search" id="search-btn" class="btn btn-flat">
            <i class="fa fa-search"></i>
          </button>
        </span>
      </div>
    </form>

    <ul class="sidebar-menu" data-widget="tree">
      <li v-if="isGranted('ROLE_COMPANY_LIST')"><router-link :to="{ name: 'CompanyList' }"><i class="fa fa-star"></i> <span>{{ $t('menu.companies') }}</span></router-link></li>
      <li v-if="isGranted('ROLE_PRODUCT_LIST')"><router-link :to="{ name: 'ProductList' }"><i class="fa fa-product-hunt"></i> <span>{{ $t('menu.product') }}</span></router-link></li>

      <li class="treeview"
          v-if="
            isGranted('ROLE_POST_LIST') ||
            isGranted('ROLE_COUNTRY_LIST') ||
            isGranted('ROLE_CITY_LIST') ||
            isGranted('ROLE_LANGUAGE_LIST') ||
            isGranted('ROLE_CURRENCY_LIST') ||
            isGranted('ROLE_CONTACT_TYPE_LIST') ||
            isGranted('ROLE_LABEL_LIST')
          "
      >
        <a href="#">
          <i class="fa fa-list"></i> <span>{{$t('menu.dictionaries')}}</span>
          <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
        </a>
        <ul class="treeview-menu">
          <li v-if="isGranted('ROLE_COUNTRY_LIST')"><router-link :to="{ name: 'CountryList' }"><i class="fa fa-flag"></i> <span>{{$t('menu.country')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_CITY_LIST')"><router-link :to="{ name: 'CityList' }"><i class="fa fa-building"></i> <span>{{$t('menu.city')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_LANGUAGE_LIST')"><router-link :to="{ name: 'LanguageList' }"><i class="fa fa-language"></i> <span>{{$t('menu.language')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_CURRENCY_LIST')"><router-link :to="{ name: 'CurrencyList' }"><i class="fa fa-eur"></i> <span>{{$t('menu.currency')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_CONTACT_TYPE_LIST')"><router-link :to="{ name: 'ContactTypeList' }"><i class="fa fa-list"></i> <span>{{$t('menu.contact_type')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_LABEL_LIST')"><router-link :to="{ name: 'LabelList' }"><i class="fa fa-list"></i> <span>{{$t('menu.label')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_CATEGORY_LIST')"><router-link :to="{ name: 'CategoryList' }"><i class="fa fa-list"></i> <span>{{$t('menu.category')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_POST_LIST')"><router-link :to="{ name: 'PostList' }"><i class="fa fa-file-o"></i> <span>{{ $t('menu.post') }}</span></router-link></li>
        </ul>
      </li>

      <li class="treeview"
          v-if="isGranted('ROLE_USER_LIST') || isGranted('ROLE_GROUP_LIST')"
      >
        <a href="#">
          <i class="fa fa-shield"></i> <span>{{$t('menu.users')}}</span>
          <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
        </a>
        <ul class="treeview-menu">
          <li v-if="isGranted('ROLE_USER_LIST')"><router-link :to="{ name: 'UserList' }"><i class="fa fa-user-secret"></i> <span>{{$t('menu.users')}}</span></router-link></li>
          <li v-if="isGranted('ROLE_GROUP_LIST')"><router-link :to="{ name: 'GroupList' }"><i class="fa fa-shield"></i> <span>{{$t('menu.groups')}}</span></router-link></li>
        </ul>
      </li>
      <li>
        <a href="#" @click.prevent="SignOut">
          <i class="fa fa-user"></i> <span>{{$t('auth.signout')}}</span>
        </a>
      </li>
    </ul>
  </section>
</aside>

</template>

<script>
export default {
  name: 'LeftSidebarSlot',
  data () {
    return {
      q: ''
    }
  },
  computed: {
    username () {
      return this.$store.getters['auth/jwtDecoded']['name']
    },
    language () {
      return this.$store.getters['auth/language']
    }
  },
  methods: {
    search () {
      window.location.href = '/search?q=' + this.q
    },
    SignOut () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$i18n.locale = this.language
      })
    }
  }
}
</script>
